import { graphql, Link } from 'gatsby';

import { Grid2 as Grid, styled } from '@mui/material';

import { ResponsiveGrid, TeaserWithImage } from '@mewa/ui';

import { imagePopulate } from '../../../../libs/strapi-populates';
import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';
import { StrapiImage, StrapiResponsiveImageData } from './image';

export const TeaserWithImageFragment = graphql`
  fragment TeaserWithImageFragment on STRAPI__COMPONENT_SHARED_TEASER_WITH_IMAGE {
    strapi_component
    title: Title
    linkLabel: LinkLabel
    linkUrl: LinkUrl
    image: Image {
      ...StrapiImageFragment
    }
  }
`;

export const componentName = 'shared.teaser-with-image';

export type TeaserWithImageData = {
  title: string;
  linkLabel: string;
  linkUrl: string;
  image: StrapiResponsiveImageData;
  strapi_component: typeof componentName;
};

export type TeaserWithImagePreview = {
  strapi_component: typeof componentName;
  Title: string;
  LinkLabel: string;
  LinkUrl: string;
  Image: StrapiResponsiveImageData;
};

export const isTeaserWithImage = (
  component: PossibleContentSections,
): component is TeaserWithImageData => {
  return component.strapi_component === componentName;
};

export const StrapiTeaserWithImage = ({
  image,
  title,
  linkLabel,
  linkUrl,
}: ComponentProps<TeaserWithImageData>) => {
  return (
    <Wrapper>
      <ResponsiveGrid>
        <Grid size={12}>
          <TeaserWithImage
            useStandardTeaserGrid={false}
            wideTeaser
            LinkComponent={Link}
            image={<StrapiImage responsiveImage={image} />}
            title={title}
            linkLabel={linkLabel}
            link={linkUrl}
          />
        </Grid>
      </ResponsiveGrid>
    </Wrapper>
  );
};

const Wrapper = styled('div')({
  marginBottom: '50px',
});

export const config = {
  isComponent: isTeaserWithImage,
  Component: StrapiTeaserWithImage,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  populationParams: { Image: imagePopulate },
  componentName,
  mapProperties: (teaserWithImage): TeaserWithImageData | null =>
    teaserWithImage.strapi_component === componentName
      ? {
          strapi_component: componentName,
          title: teaserWithImage.Title,
          linkLabel: teaserWithImage.LinkLabel,
          linkUrl: teaserWithImage.LinkUrl,
          image: teaserWithImage.Image,
        }
      : null,
};
